import { useEffect, useState } from "react";
import PhoneForm from 'components/TimelinePageOne/Screen/Login/PhoneForm';
import VerifyForm from 'components/TimelinePageOne/Screen/Login/VerifyForm';
import './index.scss';
import { getItem, setItem, setRefreshTokenCookie } from "lib/Storage";
import { useSearchParams } from "react-router-dom";
import useInputKeys from "hooks/useInputKeys";

function Login() {
  const [step, setStep] = useState(1);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const { setIsLoggedIn } = useInputKeys();
  useEffect(() => {
    let possibleToken = searchParams.get("t");
    if (possibleToken) {
      setRefreshTokenCookie(possibleToken);
      setIsLoggedIn(true);
      let existingLanguage = getItem('lng');
      if (!existingLanguage) {
        setItem('lng', "en");
        setItem('dir', "ltr");
      }
      searchParams.delete("t")
      setSearchParams(searchParams)
    }

  }, [searchParams])
  return (
    <div className="login-wrapper">
      {
        step === 1 ? (
          <PhoneForm
            phoneNumber={phoneNumber}
            setPhoneNumber={setPhoneNumber}
            setStep={setStep}
          />
        ) : (
          <VerifyForm
            phoneNumber={phoneNumber}
            setPhoneNumber={setPhoneNumber}
            setStep={setStep}
          />
        )
      }
    </div>
  );
};

export default Login;
